export default __webpack_public_path__ + "static/media/CBS-Other-Icon.8d902bec.svg";